import { render, staticRenderFns } from "./PsPatientStatus.vue?vue&type=template&id=39cf11bb&scoped=true&"
import script from "./PsPatientStatus.vue?vue&type=script&lang=js&"
export * from "./PsPatientStatus.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientStatus.vue?vue&type=style&index=0&id=39cf11bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf11bb",
  null
  
)

export default component.exports